(function () {
  const TZ = 'America/Toronto';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function partsInTz(date, timeZone) {
    const fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    const map = {};
    for (const p of fmt.formatToParts(date)) {
      if (p.type !== 'literal') map[p.type] = p.value;
    }
    if (map.hour === '24') map.hour = '00';
    return map;
  }

  function weekdayIndex(short) {
    return { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[short];
  }

  function parseHours(raw) {
    if (!raw || !String(raw).trim()) return null;
    const s = String(raw).trim().toLowerCase();
    if (s === 'closed' || s === 'none') return null;
    const m = s.match(/^(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
    if (!m) return null;
    return {
      openMin: Number(m[1]) * 60 + Number(m[2]),
      closeMin: Number(m[3]) * 60 + Number(m[4]),
    };
  }

  function parseFixedTimes(raw) {
    return String(raw || '10:00,14:00')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
      .map((label) => {
        const m = label.match(/^(\d{1,2}):(\d{2})$/);
        if (!m) return null;
        return { label: `${pad(Number(m[1]))}:${pad(Number(m[2]))}`, minutes: Number(m[1]) * 60 + Number(m[2]) };
      })
      .filter(Boolean);
  }

  function ymdFromParts(p) {
    return `${p.year}-${p.month}-${p.day}`;
  }

  function buildFixedSlots(fixedTimes, dayEarliestMin) {
    return fixedTimes.filter((t) => t.minutes >= dayEarliestMin).map((t) => t.label);
  }

  function init(root) {
    const dateEl = root.querySelector('[data-pickup-date]');
    const timeEl = root.querySelector('[data-pickup-time]');
    const statusEl = root.querySelector('[data-pickup-status]');
    const errorEl = root.querySelector('[data-pickup-error]');
    const pickupLocation = root.dataset.pickupLocation || '';
    const hasDeli = root.dataset.hasDeli === 'true';
    const cartMixed = root.dataset.cartMixed === 'true';

    if (!dateEl || !timeEl) return;

    function setCheckoutEnabled(enabled) {
      document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((btn) => {
        btn.disabled = !enabled;
        btn.classList.toggle('pickup-checkout-blocked', !enabled);
        if (!enabled) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
      });
      document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((el) => {
        el.classList.toggle('pickup-checkout-blocked', !enabled);
        el.toggleAttribute('inert', !enabled);
      });
    }

    const leadHours = hasDeli ? Number(root.dataset.leadHours || 48) : Number(root.dataset.storeLeadHours || 0);
    const daysAhead = Number(root.dataset.daysAhead || 14);
    const fixedTimes = parseFixedTimes(root.dataset.pickupTimes);
    const minSubtotalCents = Number(root.dataset.minSubtotalCents || 0);
    const enforceMin = root.dataset.enforceMinSubtotal === 'true';
    const cartSubtotalCents = Number(root.dataset.cartSubtotalCents || 0);
    const blackout = new Set(
      String(root.dataset.blackoutDays || '0,1')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .map(Number)
    );
    const holidays = new Set(
      String(root.dataset.holidays || '')
        .split(/[\n,]+/)
        .map((s) => s.trim())
        .filter(Boolean)
    );
    const hoursByDow = {
      0: parseHours(root.dataset.hoursSun),
      1: parseHours(root.dataset.hoursMon),
      2: parseHours(root.dataset.hoursTue),
      3: parseHours(root.dataset.hoursWed),
      4: parseHours(root.dataset.hoursThu),
      5: parseHours(root.dataset.hoursFri),
      6: parseHours(root.dataset.hoursSat),
    };

    const dayOptions = [];
    const now = new Date();
    const nowParts = partsInTz(now, TZ);

    let cursor = new Date(`${nowParts.year}-${nowParts.month}-${nowParts.day}T12:00:00`);
    for (let i = 0; i < daysAhead + 7 && dayOptions.length < daysAhead; i++) {
      const p = partsInTz(cursor, TZ);
      const ymd = ymdFromParts(p);
      const dow = weekdayIndex(p.weekday);
      const hours = hoursByDow[dow];
      const isBlackout = blackout.has(dow) || holidays.has(ymd) || !hours;

      const leadMs = leadHours * 60 * 60 * 1000;
      const earliest = new Date(now.getTime() + leadMs);
      const earliestParts = partsInTz(earliest, TZ);
      const earliestYmd = ymdFromParts(earliestParts);
      const earliestMinOfDay = Number(earliestParts.hour) * 60 + Number(earliestParts.minute);

      let dayEarliest = 0;
      if (ymd < earliestYmd) {
        cursor = new Date(cursor.getTime() + 24 * 60 * 60 * 1000);
        continue;
      }
      if (ymd === earliestYmd) dayEarliest = earliestMinOfDay;

      const slots = isBlackout ? [] : buildFixedSlots(fixedTimes, dayEarliest);
      if (slots.length) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const pretty = `${p.weekday} ${months[Number(p.month) - 1]} ${Number(p.day)}`;
        dayOptions.push({ ymd, dow, label: pretty, slots });
      }
      cursor = new Date(cursor.getTime() + 24 * 60 * 60 * 1000);
    }

    const placeholder = dateEl.options[0] ? dateEl.options[0].cloneNode(true) : null;
    dateEl.innerHTML = '';
    if (placeholder) dateEl.appendChild(placeholder);
    else {
      const o = document.createElement('option');
      o.value = '';
      o.textContent = 'Select a date';
      dateEl.appendChild(o);
    }
    for (const day of dayOptions) {
      const o = document.createElement('option');
      o.value = day.ymd;
      o.textContent = day.label;
      o.dataset.slots = JSON.stringify(day.slots);
      dateEl.appendChild(o);
    }

    function minOrderMet() {
      if (!enforceMin || minSubtotalCents <= 0) return true;
      return cartSubtotalCents >= minSubtotalCents;
    }

    function money(cents) {
      return (cents / 100).toFixed(2);
    }

    function unmetReasons() {
      const reasons = [];
      if (!minOrderMet()) {
        const short = Math.max(0, minSubtotalCents - cartSubtotalCents);
        reasons.push(
          `Add $${money(short)} more in deli items. The $${money(minSubtotalCents)} minimum is not met, so checkout is closed.`
        );
      }
      if (!dateEl.value || !timeEl.value) {
        reasons.push('Choose a pickup date and time (10:00 am or 2:00 pm) before checkout.');
      }
      return reasons;
    }

    function showBlocked(reasons) {
      statusEl.replaceChildren();
      reasons.forEach((text, i) => {
        const line = document.createElement('span');
        line.className = 'pickup-scheduler__status-line';
        line.textContent = text;
        statusEl.appendChild(line);
        if (i < reasons.length - 1) statusEl.appendChild(document.createElement('br'));
      });
      statusEl.classList.add('pickup-scheduler__status--blocked');
      errorEl.hidden = true;
      setCheckoutEnabled(false);
    }

    function updateStatus() {
      const date = dateEl.value;
      const time = timeEl.value;
      const reasons = unmetReasons();

      if (reasons.length) {
        showBlocked(reasons);
        return;
      }

      statusEl.classList.remove('pickup-scheduler__status--blocked');
      const dateLabel = dateEl.selectedOptions[0] ? dateEl.selectedOptions[0].textContent.trim() : date;
      const timeLabel = timeEl.selectedOptions[0] ? timeEl.selectedOptions[0].textContent.trim() : time;
      const where = pickupLocation ? `Pickup at ${pickupLocation}: ` : 'Pickup: ';
      let message = `${where}${dateLabel} at ${timeLabel}. Saved on each deli item for the kitchen.`;
      if (cartMixed) message += ' Store items ship or pick up at Muskoka Natural Food Market.';
      statusEl.textContent = message;
      errorEl.hidden = true;
      setCheckoutEnabled(true);
      saveAttributes(date, time, `${dateLabel} at ${timeLabel}`);
    }

    function saveAttributes(date, time, pickupLabel) {
      const attributes = {
        'Pickup date': date,
        'Pickup time': time,
        Pickup: pickupLabel,
      };
      if (pickupLocation) attributes['Pickup location'] = pickupLocation;
      const keys = String(root.dataset.deliLineKeys || '')
        .split(',')
        .map((key) => key.trim())
        .filter(Boolean);
      const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      const writeLines = async () => {
        let cart = await fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        for (const key of keys) {
          const line = (cart.items || []).find((item) => item.key === key);
          if (!line) continue;
          const existing = line.properties && !Array.isArray(line.properties) ? line.properties : {};
          const res = await fetch(rootUrl + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity: line.quantity,
              properties: Object.assign({}, existing, { Pickup: pickupLabel }),
              sections: 'cart-items',
              sections_url: window.location.pathname,
            }),
          });
          cart = await res.json();
          if (!res.ok) throw new Error('line update failed');
        }
        const sectionHtml = cart.sections && cart.sections['cart-items'];
        const holder = document.getElementById('shopify-section-cart-items');
        if (sectionHtml && holder) {
          if (sectionHtml.indexOf('id="shopify-section-cart-items"') !== -1) holder.outerHTML = sectionHtml;
          else holder.innerHTML = sectionHtml;
        }
        await fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        });
      };

      writeLines().catch(() => {
        errorEl.hidden = false;
        errorEl.textContent = 'Could not save pickup details. Try again.';
      });
    }

    dateEl.addEventListener('change', () => {
      const opt = dateEl.selectedOptions[0];
      const slots = opt && opt.dataset.slots ? JSON.parse(opt.dataset.slots) : [];
      timeEl.innerHTML = '';
      const ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Select a time';
      timeEl.appendChild(ph);
      for (const s of slots) {
        const o = document.createElement('option');
        o.value = s;
        o.textContent = s === '10:00' ? '10:00 am' : s === '14:00' ? '2:00 pm' : s;
        timeEl.appendChild(o);
      }
      timeEl.disabled = slots.length === 0;
      updateStatus();
    });

    timeEl.addEventListener('change', updateStatus);

    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
        if (!btn) return;
        const reasons = unmetReasons();
        if (reasons.length) {
          e.preventDefault();
          showBlocked(reasons);
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      },
      true
    );

    updateStatus();
  }

  document.querySelectorAll('[data-pickup-scheduler]').forEach(init);
})();
